export const BACKGROUNDS_FETCHING_ERROR_PREFIX = 'Failed to fetch backgrounds';
export const PATHWAYS_AND_COMPARTMENTS_BACKGROUND = 'Pathways and compartments';
export const SEMANTIC_BACKGROUND = 'Semantic';
